import axios from "axios";
import _ from "lodash";
import { toast } from "react-toastify";

import {
    GET_STORE,
    GET_STORES,
    DELETE_STORE,
    ADD_STORE,
    UPDATE_STORE
} from "../types";

const basePath = process.env.REACT_APP_API_URL + "/api/store";

export const getStores = () => async dispatch => {
    try {
        const res = await axios.get(`${basePath}/viewAll`);

        dispatch({
            type: GET_STORES,
            payload: res.data
        });

        return res.data.stores;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const getPaginateStores = (query) => async dispatch => {
    try {
        const res = await axios.get(`${basePath}/viewAll`, {
            params: query
        });

        dispatch({
            type: GET_STORES,
            payload: res.data
        });

        return res.data;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
}

export const getStore = id => async dispatch => {
    try {
        const res = await axios.get(`${basePath}/view/${id}`);

        dispatch({ type: GET_STORE });

        return res.data.store;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const addStore = data => async dispatch => {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    };

    try {
        let formData = new FormData();

        formData.append("name", data.name);
        formData.append("website", data.website);
        formData.append("description", data.description);
        formData.append("facebook", data.facebook);

        const categoryIds = data.categoryIds;
        if (categoryIds.length) {
            categoryIds.forEach(categoryId => {
                formData.append("categoryIds[]", categoryId);
            });
        }

        if (_.isArray(data.images) && data.images.length)
            formData.append("image", data.images[0]);

        // const res = await axios.post(`${basePath}/add`, formData, config);
        const res = await axios.post(process.env.REACT_APP_API_URL + "/api/mobile/page/create", formData, config);

        dispatch({
            type: ADD_STORE,
            payload: res.data
        });

        toast.success("Store Created.");

        return res.data;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const updateStore = (data, id) => async dispatch => {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    };

    try {
        let formData = new FormData();

        formData.append("name", data.name);
        formData.append("website", data.website);
        formData.append("facebook", data.facebook);
        formData.append("description", data.description);

        const categoryIds = data.categoryIds;
        if (categoryIds.length) {
            categoryIds.forEach(categoryId => {
                formData.append("categoryIds[]", categoryId);
            });
        }

        if (_.isArray(data.images) && data.images.length)
            formData.append("image", data.images[0]);

        if (_.isArray(data.files) && data.files.length)
            formData.append("file", data.files[0]);

        const res = await axios.put(
            `${basePath}/update/${id}`,
            formData,
            config
        );

        dispatch({
            type: UPDATE_STORE,
            payload: res.data
        });

        toast.success("Store Updated.");

        return res.data;
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

export const deleteStore = id => async dispatch => {
    try {
        await axios.delete(`${basePath}/delete/${id}`);

        dispatch({
            type: DELETE_STORE,
            payload: id
        });
        
        toast.success("Store Deleted.");
    } catch (err) {
        if (err.response !== undefined) {
            const error = err.response.data.message;

            toast.error(error);
        }
    }
};

